export const UnsupportedScript = () => (
  <script
    dangerouslySetInnerHTML={{
      __html: `(function() {
      var host = window.location.hostname;
      var ua = window.navigator.userAgent;
      var redirect = '/unsupported';
      // test if browser is  <= IE10
      var msie = ua.indexOf('MSIE');
      if (msie > 0) {
          window.location.href = redirect;
      }
      // test if browser is IE11
      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        window.location.href = redirect;
      }
    })();`,
    }}
  />
);
